<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form"
            size="mini"
            @submit.native.prevent="onSubmit"
        >

            <el-form-item label="负责人：" class="query-form-item" v-show="pageType===1">
                <el-select v-model="query.operator_id" placeholder="请选择" size="mini" style="width: 110px">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.full_name" :value="item.id" :key="item.id"
                               v-for="item in managerAnalysisList"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="广告控制人：" class="query-form-item" v-show="pageType===1">
                <el-select v-model="query.controller_id" placeholder="请选择" size="mini" style="width: 110px">
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.full_name" :value="item.id" :key="item.id"
                               v-for="item in managerAnalysisList"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ID：" class="query-form-item">
                <el-input
                    v-model="query.id"
                    placeholder="请输入ID"
                    style="width:110px"
                    clearable
                    @keyup.enter.native="searchForm"
                ></el-input>
            </el-form-item>
            <el-form-item label="ASIN:" class="query-form-item">
                <el-input
                    v-model="query.asin"
                    placeholder="请输入ASIN"
                    style="width:160px"
                    clearable
                    @keyup.enter.native="searchForm"
                ></el-input>
            </el-form-item>

            <el-form-item label="Auto优化：" class="query-form-item">
                <el-select v-model="query.auto_is_begin" placeholder="请选择" size="mini" style="width: 110px">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="关" :value="0"></el-option>
                    <el-option label="开" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Asin优化：" class="query-form-item">
                <el-select v-model="query.asin_is_begin" placeholder="请选择" size="mini" style="width: 110px">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="关" :value="0"></el-option>
                    <el-option label="开" :value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Skag优化：" class="query-form-item">
                <el-select v-model="query.skag_is_begin" placeholder="请选择" size="mini" style="width: 110px">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="关" :value="0"></el-option>
                    <el-option label="开" :value="1"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="国家：" class="query-form-item">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 100px;"
                    size="mini"
                    filterable
                    clearable
                >
                    <el-option v-for="item in $common.us_arr" :key="item.us" :label="item.title" :value="item.us"
                               :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注:" class="query-form-item">
                <el-input
                    v-model="query.remark"
                    placeholder="请输入备注"
                    style="width:160px"
                    clearable
                ></el-input>
            </el-form-item>

            <el-form-item label="是否有项目预算Asin：" class="query-form-item">
                <el-select v-model="query.have_project_budget_asin" placeholder="请选择" size="mini" style="width: 110px">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <!--            have_project_budget_asin-->

            <el-form-item label="使用状态：" class="query-form-item">
                <el-select v-model="query.using" placeholder="请选择" size="mini" style="width: 110px">
                    <el-option label="全部" :value="undefined"></el-option>
                    <el-option label="正常" :value="1"></el-option>
                    <el-option label="失效" :value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button
                    icon="el-icon-search"
                    type="primary"
                    @click="onSubmit"
                    native-type="submit"
                >查询
                </el-button
                >
                <el-button type="primary" @click="openSearchVolume">搜索量</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="negativeMapping">否定投放词映射</el-button>
                <el-button type="success" icon="el-icon-plus" @click="add">添加ASIN</el-button>
                <el-button type="success" @click="onplural"
                >查看词根单复数
                </el-button
                >
                <el-button type="primary" @click="autoOptimize('NA')">美国Acos优化</el-button>
                <el-button type="primary" @click="autoOptimize('EU')">欧洲Acos优化</el-button>
                <el-button type="success" @click="exportFunc" v-show="pageType===1">导出</el-button>
            </el-form-item>
        </el-form>
        <el-dialog
            width="900px"
            title="搜索量"
            :visible.sync="searchVolumeDialogVisible"
        >
            <div style="margin-bottom: 10px;">
                <el-input
                    v-model="searchVolumeQuery.keyword"
                    placeholder="请输入关键词"
                    style="width: 240px; margin-right: 10px;"
                    clearable
                    size="mini"
                    @keyup.enter.native="fetchSearchVolume"
                ></el-input>
                <el-button type="primary" size="mini" @click="fetchSearchVolume">查询</el-button>
                <el-button size="mini" @click="resetSearchVolume">重置</el-button>
                <el-button type="success" size="mini" @click="openSearchVolumeImport">导入</el-button>
            </div>
            <el-table
                v-loading="searchVolumeLoading"
                :data="searchVolumeList"
                size="mini"
                border
                :height="400"
                style="width: 100%;"
            >
                <el-table-column label="关键词" prop="keyword" min-width="160" align="center"></el-table-column>
                <el-table-column label="Exact关键词" prop="exact_keyword" min-width="160" align="center"></el-table-column>
                <el-table-column label="排名" prop="aba_rank" min-width="120" align="center"></el-table-column>
                <el-table-column label="搜索量" prop="search_volume" min-width="120" align="center"></el-table-column>
                <el-table-column label="更新时间" prop="add_time" min-width="180" align="center"></el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 10px;">
                <el-pagination
                    @size-change="handleSearchVolumeSizeChange"
                    @current-change="handleSearchVolumePageChange"
                    :page-size="searchVolumeQuery.limit"
                    :page-sizes="[20, 50, 100]"
                    :current-page="searchVolumeQuery.page"
                    :total="searchVolumeQuery.total"
                    background
                    layout="total, sizes, prev, pager, next"
                >
                </el-pagination>
            </div>
        </el-dialog>
        <el-dialog
            width="520px"
            title="导入搜索量"
            :visible.sync="searchVolumeImportVisible"
        >
            <div style="margin-bottom: 12px;">
                <a
                    href="/export/搜索量模版.xlsx"
                    style="text-decoration: underline; color: rgb(58, 142, 230);"
                >点击下载“搜索量模版.xlsx”</a>
            </div>
            <el-upload
                class="upload-demo"
                drag
                action="/"
                accept=".xls, .xlsx"
                :file-list="searchVolumeImportFiles"
                :http-request="() => {}"
                :on-change="handleSearchVolumeFileChange"
                :on-remove="handleSearchVolumeRemove"
                :auto-upload="false"
                :limit="1"
                multiple
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                </div>
                <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">
                    只能上传.xls/.xlsx文件
                </div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="closeSearchVolumeImport">取 消</el-button>
                <el-button type="primary" size="mini" :loading="searchVolumeImportLoading" @click="submitSearchVolumeImport">确 定</el-button>
            </span>
        </el-dialog>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            class="table_content etyme_index"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @row-click="clickRowHandle"
            @expand-change="clickRowHandle1"
            border
            style="width: 100%;"
            :height="tableHeight"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <inline
                        @getList="getList"
                        :ref="'inline' + props.row.id"
                        :datasrow="props.row"
                    ></inline>
                </template>
            </el-table-column>
            <el-table-column
                label="id" width="80" :resizable="false" prop="id" align="center">
            </el-table-column>
            <el-table-column label="图片" width="120" align="center">
                <template slot-scope="scope">
                    <div style="width: 100px;height: 100px;" slot="reference">
                        <img style="width:100%;height:100%;" :src="scope.row.asin_img" alt/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="ASIN" width="215" align="center" class-name="asin-column-cell">
                <template slot-scope="scope">
                    <div style="padding: 22px 0 10px 0;">
                        <el-badge :value="scope.row.running_status == -1 ? '变狗' : '' " class="item">
                            <span v-if="scope.row.asin != null" @click.stop="edirectToAsin(scope.row)"
                                  style="cursor: pointer;color: rgb(52, 73, 94);">
                                <i class="el-icon-s-promotion" style="margin-right:5px;"></i>
                            </span>
                            <icon-svg
                                :icon-class="scope.row.state.toUpperCase()"
                                :style="{ fontSize: '24px', marginLeft: '5px', opacity: (scope.row.using === 0 || scope.row.using === '0') ? 0.6 : 1 }"
                                v-if="scope.row.state"
                            ></icon-svg>
                            <span style="position: relative; display: inline-block;">
                                <span
                                    @click="updateAsin(scope.row)"
                                    :style="{
                                        cursor: 'pointer',
                                        color: (scope.row.using === 0 || scope.row.using === '0') ? '#909399' : 'inherit',
                                        fontWeight: (scope.row.using === 0 || scope.row.using === '0') ? 'normal' : '500'
                                    }"
                                >{{ scope.row.asin }}</span>
                                <img
                                    v-if="scope.row.using === 0 || scope.row.using === '0'"
                                    src="@/assets/image/invalid_stamp.png"
                                    class="asin-invalid-stamp-img"
                                    alt="已失效"
                                />
                            </span>
                            <div>父:{{scope.row.parent_asin}}</div>

                        </el-badge>
                    </div>
                </template>
            </el-table-column>


            <el-table-column label="广告组合" min-width="250" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.portfolio" class="scrollHeight">
                        <div v-for="(item, index) in scope.row.portfolio" :key="item.portfolio_id || index" style="text-align: left">
                            <span v-show="item.country">【{{ item.country }}】</span>
                            <span v-show="item.shop_name">【{{ item.shop_name }}】</span>
                            <span v-show="item.portfolio_name">{{ item.portfolio_name }}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="负责人" width="100" align="center" v-if="pageType === 1">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.username }} <br/>
                        {{ scope.row.fullname }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="广告控制人" width="100" align="center" v-if="pageType === 1">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.controller_username }} <br/>
                        {{ scope.row.controller_fullname }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Teambition任务" width="270" align="center">
                <template slot-scope="scope">
                    <div @click="openTaskList(scope.row)" style="cursor: pointer;">
                        {{ scope.row.teambition_project_name }} <br/>
                        {{ scope.row.teambition_task_content }} <br/>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Teambition状态" width="150" align="center">
                <template slot-scope="scope">
                    <div v-show="scope.row.tfs_name" style="color:green;font-weight:900;letter-spacing: 2px;">
                        {{ scope.row.tfs_name }}
                    </div>
                    <div v-show="scope.row.teambition_url" @click="jumpUrl(scope.row.teambition_url)"
                         style="color:blue;cursor: pointer;">任务详情
                    </div>

                </template>
            </el-table-column>



            <el-table-column label="广告优化" width="230" align="center">
                <template slot-scope="scope">

                    <div style="display: flex;font-weight: bold;"
                         v-if="scope.row.auto_acos_is_begin != null && scope.row.auto_acos != null &&
                               scope.row.asin_acos_is_begin != null && scope.row.asin_acos != null &&
                               scope.row.res_acos_is_begin != null && scope.row.res_acos != null &&
                               scope.row.skag_per_acos_is_begin != null && scope.row.skag_per_acos != null &&
                               scope.row.per_acos_is_begin != null && scope.row.per_acos != null">
                        <div style="width: 60px;text-align: right">类型</div>
                        <div style="width: 70px;">状态</div>
                        <div style="width: 70px;text-align: left">系数</div>
                    </div>

                    <span style="text-align: right; width: 60px; display:inline-block;"
                          v-if="scope.row.auto_acos_is_begin != null && scope.row.auto_acos != null"
                    >Auto:</span>
                    <span v-if="scope.row.auto_acos_is_begin != null"
                          style="width: 70px;text-align: center;display: inline-block"
                          :style="{color: scope.row.auto_acos_is_begin == 1 ? 'green': 'red'}">
                    {{ scope.row.auto_acos_is_begin == 1 ? '开' : '关' }}
                   </span>
                    <span v-if="scope.row.auto_acos != null" style="width: 70px;text-align: left;display: inline-block"
                          :style="{color: scope.row.auto_acos_is_begin == 1 ? 'green': 'red'}">
                        {{
                            scope.row['auto_acos'] ? accMul(scope.row['auto_acos'], 100) + '%' : '-'
                        }}
                    </span>
                    <br/>

                    <span style="text-align: right; width: 60px; display:inline-block;"
                          v-if="scope.row.asin_acos_is_begin != null && scope.row.asin_acos != null"
                    >Asin:</span>
                    <span v-if="scope.row.asin_acos_is_begin != null"
                          style="width: 70px;text-align: center;display: inline-block"
                          :style="{color: scope.row.asin_acos_is_begin == 1 ? 'green': 'red'}">
                    {{ scope.row.asin_acos_is_begin == 1 ? '开' : '关' }}
                   </span>
                    <span v-if="scope.row.asin_acos != null" style="width: 70px;text-align: left;display: inline-block"
                          :style="{color: scope.row.asin_acos_is_begin == 1 ? 'green': 'red'}">
                        {{
                            scope.row['asin_acos'] ? accMul(scope.row['asin_acos'], 100) + '%' : '-'
                        }}
                    </span>
                    <br/>

                    <span style="text-align: right; width: 60px; display:inline-block;"
                          v-if="scope.row.res_acos_is_begin != null && scope.row.res_acos != null"
                    >Res:</span>
                    <span v-if="scope.row.res_acos_is_begin != null"
                          style="width: 70px;text-align: center;display: inline-block"
                          :style="{color: scope.row.res_acos_is_begin == 1 ? 'green': 'red'}">
                    {{ scope.row.res_acos_is_begin == 1 ? '开' : '关' }}
                     </span>
                    <span v-if="scope.row.res_acos != null" style="width: 70px;text-align: left;display: inline-block"
                          :style="{color: scope.row.res_acos_is_begin == 1 ? 'green': 'red'}">
                        {{
                            scope.row['res_acos'] ? accMul(scope.row['res_acos'], 100) + '%' : '-'
                        }}
                    </span>
                    <br/>

                    <span style="text-align: right; width: 60px; display:inline-block;"
                          v-if="scope.row.skag_per_acos_is_begin != null && scope.row.skag_per_acos != null"
                    >Skag-per:</span>
                    <span v-if="scope.row.skag_per_acos_is_begin != null"
                          style="width: 70px;text-align: center;display: inline-block"
                          :style="{color: scope.row.skag_per_acos_is_begin == 1 ? 'green': 'red'}">
                        {{ scope.row.skag_per_acos_is_begin == 1 ? '开' : '关' }}
                    </span>
                    <span v-if="scope.row.skag_per_acos != null"
                          style="width: 70px;text-align: left;display: inline-block"
                          :style="{color: scope.row.skag_per_acos_is_begin == 1 ? 'green': 'red'}">
                        {{
                            scope.row['skag_per_acos'] ? accMul(scope.row['skag_per_acos'], 100) + '%' : '-'
                        }}
                    </span>
                    <br/>

                    <span style="text-align: right; width: 60px; display:inline-block;"
                          v-if="scope.row.per_acos_is_begin != null && scope.row.per_acos != null"
                    >Per:</span>
                    <span v-if="scope.row.per_acos_is_begin != null"
                          style="width: 70px;text-align: center;display: inline-block"
                          :style="{color: scope.row.per_acos_is_begin == 1 ? 'green': 'red'}">
                        {{ scope.row.per_acos_is_begin == 1 ? '开' : '关' }}
                    </span>
                    <span v-if="scope.row.per_acos != null" style="width: 70px;text-align: left;display: inline-block"
                          :style="{color: scope.row.per_acos_is_begin == 1 ? 'green': 'red'}">
                        {{
                            scope.row['per_acos'] ? accMul(scope.row['per_acos'], 100) + '%' : '-'
                        }}
                    </span>
                    <br/>

                </template>
            </el-table-column>

            <el-table-column label="广告组合SP广告搜索词日期" width="180" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.ad_put_keyword_early_date }}</div>
                    <div>{{ scope.row.ad_put_keyword_late_date }}</div>
                </template>
            </el-table-column>

            <el-table-column label="项目预算asin" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.project_budget_asin }}</div>
                </template>
            </el-table-column>

            <el-table-column label="CPA广告数据" min-width="370" align="center">
                <template slot-scope="scope">
                    <div>
                        <div>
                            <span style="width: 160px;display: inline-block;text-align: right;">日期:</span>
                            <span style="width: 160px;display: inline-block;text-align: left;padding-left: 10px;">{{
                                    scope.row.date || '-'
                                }}</span>
                        </div>
                        <div>
                            <span style="width: 160px;display: inline-block;text-align: right;
                            ">毛利率(没扣广告):</span>
                            <span style="width: 160px;display: inline-block;text-align: left;padding-left: 10px;">{{
                                    scope.row['gross_profit_rate'] ? accMul(scope.row['gross_profit_rate'], 100)
                                        + '%' : '-'
                                }}</span>
                        </div>
                        <div>
                            <span style="width: 160px;display: inline-block;text-align: right;
                            ">ACOS(周期天数日均):</span>
                            <span style="width: 160px;display: inline-block;text-align: left;padding-left: 10px;">{{
                                    scope.row['acos'] ? accMul(scope.row['acos'], 100)
                                        + '%' : '-'
                                }}</span>
                        </div>
                        <div>
                            <span style="width: 160px;display: inline-block;text-align: right;
                            ">广告单占比(周期天数日均):</span>
                            <span style="width: 160px;display: inline-block;text-align: left;padding-left: 10px;"
                                  :style="{color: (scope.row.ad_order_rate||0) > 0.5 ? 'red': ''}">{{
                                    scope.row['ad_order_rate'] ? accMul(scope.row['ad_order_rate'], 100)
                                        + '%' : '-'
                                }}</span>
                        </div>
                        <div>
                            <span style="width: 160px;display: inline-block;text-align: right;
                            ">毛利/获客成本(毛利没扣广告):</span>
                            <span style="width: 160px;display: inline-block;text-align: left;padding-left: 10px;">{{
                                    scope.row['gross_profit_customer_cost_rate'] ? accMul(scope.row['gross_profit_customer_cost_rate'], 100)
                                        + '%' : '-'
                                }}</span>
                        </div>
                        <div>
                            <span style="width: 160px;display: inline-block;text-align: right;
                            ">父体净利润(扣运营成本):</span>
                            <span style="width: 160px;display: inline-block;text-align: left;padding-left: 10px;">{{
                                    scope.row.parent_net_profit || '-'
                                }}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="备注" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.remark }}</div>
                </template>
            </el-table-column>


            <el-table-column label="基础信息" width="400" align="center">
                <template slot-scope="scope">
                    <div style="text-align: left">
                        <div style="font-size: 16px; font-weight: 600;">{{ scope.row.asin_title }}</div>
                        <div style="font-size: 12px; font-weight: 600;">
                            更新时间：{{ scope.row.keepa_update_time }}
                        </div>
                        <div style="font-size: 12px; font-weight: 600;">价格：{{ scope.row.price }}</div>
                        <div style="font-size: 12px; font-weight: 600;">品牌：{{ scope.row.asin_brand }}</div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="创建时间" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.created_time }}</div>
                </template>
            </el-table-column>

            <el-table-column label="旧广告组" min-width="180" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.old_portfolio_name }}</div>
                    <div>{{ scope.row.old_portfolio_dates }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="200" align="center" fixed="right">
                <template slot-scope="scope">

                    <el-button type="primary" size="mini" @click="onJump(scope.row, true)">sp优化</el-button>
                    <el-button type="danger" size="mini" @click="deleteFunc(scope.row)">删除</el-button>

                </template>
            </el-table-column>


            <!--            <el-table-column label="操作" width="374">-->
            <!--                <template slot-scope="scope">-->
            <!--                    <div @click.stop>-->
            <!--                        <el-button-->
            <!--                            style="margin: 5px 0 5px 10px"-->
            <!--                            size="mini"-->
            <!--                            @click.native="onJump(scope.row, true)"-->
            <!--                        >跳转SP广告优化-->
            <!--                        </el-button-->
            <!--                        >-->
            <!--                        <el-button-->
            <!--                            style="margin: 5px 0 5px 10px"-->
            <!--                            size="mini"-->
            <!--                            @click.native="onSBJump(scope.row, true)"-->
            <!--                        >跳转SB广告优化-->
            <!--                        </el-button-->
            <!--                        >-->
            <!--                        <el-button type="primary"-->
            <!--                                   style="margin: 5px 0 5px 10px"-->
            <!--                                   size="mini"-->
            <!--                                   @click.native="keywordRanking(scope.row, true)"-->
            <!--                        >关键词排名-->
            <!--                        </el-button>-->

            <!--                        <el-button-->
            <!--                            style="margin: 5px 0 5px 10px"-->
            <!--                            type="success"-->
            <!--                            size="mini"-->
            <!--                            @click.native="sbvOpen(scope.row, false)"-->
            <!--                        >SB种子词库-->
            <!--                        </el-button>-->
            <!--                        <el-button-->
            <!--                            style="margin: 5px 0 5px 10px"-->
            <!--                            type="success"-->
            <!--                            size="mini"-->
            <!--                            @click.native="sbvOpen(scope.row, true)"-->
            <!--                        >SBV种子词库-->
            <!--                        </el-button>-->
            <!--                        <el-button-->
            <!--                            style="margin: 5px 0 5px 10px"-->
            <!--                            type="success"-->
            <!--                            size="mini"-->
            <!--                            @click.native="sdOpen(scope.row, true)"-->
            <!--                        >SD种子词库-->
            <!--                        </el-button>-->

            <!--                        <el-button-->
            <!--                            style="margin: 5px 0 5px 10px"-->
            <!--                            type="warning"-->
            <!--                            size="mini"-->
            <!--                            @click.native="recordOpen(scope.row)"-->
            <!--                        >排名掉出检测-->
            <!--                        </el-button-->
            <!--                        >-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--            </el-table-column>-->
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <add
            :visible="ctrl.addDialogVisible"
            :title="'添加ASIN'"
            @close-callback="closeCllback"
        ></add>
        <negativeMappingDialog
            :visible="ctrl.negativeMappingVisible"
            @close-callback="closeCllback"
        ></negativeMappingDialog>
        <upload
            :visible="ctrl.uploadDialogVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></upload>
        <relevance
            ref="relevance"
            :visible="ctrl.relevanceDialogVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></relevance>
        <upload1
            :visible="ctrl.upload1DialogVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></upload1>
        <onremark
            :visible="ctrl.onremarkDialogVisible"
            :formData="formData"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></onremark>
        <plural
            ref="plural"
            :visible="ctrl.pluralDialogVisible"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></plural>
        <autoOptimizeDialog
            ref="autoOptimizeRef"
            :visible="ctrl.autoOptimizeVisible"
            :title="ctrl.dialogTitle"
            @close-callback="closeCllback"
        ></autoOptimizeDialog>
        <EditAdGroupName
            v-if="showAdGroup"
            :data="adGroupData"
            @close="closeAdGroupName"
            @onUpdate="onSubmit"
        />
        <RecordList
            title="列表记录"
            :formData="formData"
            v-if="ctrl.recordDialogVisible"
            :visible="ctrl.recordDialogVisible"
            @close-callback="closeCllback"
        />
        <sbvParseList
            :title="parse.title"
            :formData="formData"
            v-if="ctrl.sbvParseVisible"
            :visible="ctrl.sbvParseVisible"
            :type="parse.type"
            @close-callback="closeCllback"
        >
        </sbvParseList>
        <sdParseList
            title="SD广告组合解析列表"
            :formData="formData"
            v-if="ctrl.sdParseVisible"
            :visible="ctrl.sdParseVisible"
            @close-callback="closeCllback"
        >
        </sdParseList>
        <store-name-list :visible="this.ctrl.uploadFileListVisible" title="店铺名称列表"
                         @close-callback="closeCllback"></store-name-list>
        <keywordRanking :visible="this.ctrl.keywordRankingVisible" title="关键词排名"
                        @close-callback="closeCllback" :formData="formData"></keywordRanking>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo" :closeFlag="true"
                          @close-callback="closeCllback"></child-info-modal>
        <store-name-list :visible="this.ctrl.uploadFileListVisible" title="店铺名称列表"
                         @close-callback="closeCllback"></store-name-list>
        <changeUser @close-callback="closeCllback" ref="changeUserDom"></changeUser>
        <updateItemModal ref="updateItemModalRef" @close-callback="closeCllback"></updateItemModal>
        <updateAsinModal ref="updateAsinModalRef" @close-callback="closeCllback"/>
        <taskListModal ref="taskListRef" @close-callback="closeCllback"/>
    </div>
</template>

<script>
import taskListModal from '@/views/etymaPhp/components/taskListModal.vue'
import updateAsinModal from '@/views/etymaPhp/components/updateAsinModal.vue'
import updateItemModal from './updataItemModal.vue'
import * as api from '@/api/Product/Product'
import {downloadFileUrl, link_us} from '@/utils/method'
import Add from './add'
import Inline from './inline'
import Upload from './upload'
import Upload1 from './upload1'
import Onremark from './onremark'
import Plural from './plural'
import Onbutton from './onbutton'
import Relevance from './relevance'
import RecordList from './recordList'
import sbvParseList from './sbvParseList'
import sdParseList from './sdParseList'
import EditAdGroupName from './components/editAdGroupName'
import {binary_download} from '@/utils/method'
import {downLoadFilePy} from '../../utils/method'
import storeNameList from './storeNameList'
import keywordRanking from './keywordRanking'
import ChildInfoModal from './childInfoModal.vue'
import tableTooptip from './tableTooptip.vue'
import changeUser from './components/changeUser'
import autoOptimizeDialog from './autoOptimizeDialog'
import {seed_word_asin_list_export} from '@/api/Product/Product'
import negativeMappingDialog from './negativeMappingDialog.vue'
import {accMul} from '@/utils/mach'

export default {
    components: {
        taskListModal,
        updateAsinModal,
        Add,
        Upload,
        Inline,
        Onremark,
        Upload1,
        Plural,
        Relevance,
        Onbutton,
        EditAdGroupName,
        RecordList,
        sbvParseList,
        sdParseList,
        ChildInfoModal,
        keywordRanking,
        tableTooptip,
        storeNameList,
        autoOptimizeDialog,
        negativeMappingDialog,
        updateItemModal,
        changeUser
    },
    data() {
        return {
            managerAnalysisList: [],
            openUrlAsin: '',
            childInfo: {},
            parse: {
                title: '',
                type: ''
            },
            adGroupData: null,
            showAdGroup: false,
            ctrl: {
                keywordRankingVisible: false,
                addDialogVisible: false,
                negativeMappingVisible: false,
                uploadFileListVisible: false,
                onremarkDialogVisible: false,
                pluralDialogVisible: false,
                upload1DialogVisible: false,
                relevanceDialogVisible: false,
                uploadDialogVisible: false,
                recordDialogVisible: false,
                sbvParseVisible: false,
                sdParseVisible: false,
                childInfoVisible: false,
                autoOptimizeVisible: false,
            },
            expands: [],
            formData: {},
            query: {
                page: 1,
                remark: '',
                limit: 20,
                using: undefined
            },
            list: [],
            cList: [],
            disabled: false,
            loading: false,
            tableHeight: null,
            searchVolumeDialogVisible: false,
            searchVolumeLoading: false,
            searchVolumeList: [],
            searchVolumeQuery: {
                keyword: '',
                page: 1,
                limit: 20,
                total: 0
            },
            searchVolumeImportVisible: false,
            searchVolumeImportLoading: false,
            searchVolumeImportFiles: []
        }
    },
    props: {
        pageType: {
            type: Number,
            default: 0
        }
    },
    mounted() {
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        },
        pageType: {
            handler(val) {
                val === 1 && this.getManagerAnalysisList()
            },
            immediate: true
        }
    },
    created() {
        this.getList()
    },
    methods: {
        accMul,
        openSearchVolume() {
            this.searchVolumeDialogVisible = true
            this.resetSearchVolume(false)
            this.fetchSearchVolume()
        },
        fetchSearchVolume() {
            this.searchVolumeLoading = true
            api.ad_for_sp_keyword_search_volume_index({
                keyword: this.searchVolumeQuery.keyword,
                page: this.searchVolumeQuery.page,
                limit: this.searchVolumeQuery.limit
            }).then(res => {
                if (res.code === 0) {
                    const data = res.data || {}
                    this.searchVolumeList = data.list || []
                    this.searchVolumeQuery.total = data.total || 0
                    this.searchVolumeQuery.page = data.page || this.searchVolumeQuery.page
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
            }).finally(() => {
                this.searchVolumeLoading = false
            })
        },
        resetSearchVolume(needFetch = true) {
            this.searchVolumeQuery.keyword = ''
            this.searchVolumeQuery.page = 1
            this.searchVolumeQuery.limit = 20
            needFetch && this.fetchSearchVolume()
        },
        handleSearchVolumePageChange(val) {
            this.searchVolumeQuery.page = val
            this.fetchSearchVolume()
        },
        handleSearchVolumeSizeChange(val) {
            this.searchVolumeQuery.limit = val
            this.searchVolumeQuery.page = 1
            this.fetchSearchVolume()
        },
        openSearchVolumeImport() {
            this.searchVolumeImportVisible = true
            this.searchVolumeImportFiles = []
        },
        handleSearchVolumeFileChange(file, fileList) {
            this.searchVolumeImportFiles = fileList.slice(-1)
        },
        handleSearchVolumeRemove(file, fileList) {
            this.searchVolumeImportFiles = fileList
        },
        closeSearchVolumeImport() {
            this.searchVolumeImportVisible = false
            this.searchVolumeImportFiles = []
            this.searchVolumeImportLoading = false
        },
        submitSearchVolumeImport() {
            if (!this.searchVolumeImportFiles.length) {
                this.$message.warning('请先选择文件')
                return
            }
            const raw = this.searchVolumeImportFiles[0].raw || this.searchVolumeImportFiles[0]
            const form = new FormData()
            form.append('file', raw)
            this.searchVolumeImportLoading = true
            api.ad_for_sp_keyword_search_volume_import(form).then(res => {
                if (res.code === 0) {
                    this.$message.success('导入成功')
                    this.closeSearchVolumeImport()
                    this.fetchSearchVolume()
                } else {
                    this.$message.error(res.message || '导入失败')
                }
            }).catch(() => {
                this.$message.error('导入失败')
            }).finally(() => {
                this.searchVolumeImportLoading = false
            })
        },
        openTaskList(data) {
            this.$refs.taskListRef.showModal(data)
        },
        updateAsin(data) {
            this.$refs.updateItemModalRef.openModal('asin', data)
        },
        deleteFunc(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.seed_word_asin_list_deleted({id: data.id}).then((res) => {
                    if (res.success) {
                        this.$message.success('删除成功')
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                })
            })
        },
        getManagerAnalysisList() {
            api.manager_index_get_seed_word_user_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.managerAnalysisList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        searchForm() {
            this.getList()
        },
        // 获取row的key值
        getRowKeys(row) {
            return row.id
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        getList() {
            this.loading = true
            const tempPromise = this.pageType === 0 ? api.seed_word_asin_list_operator_lists(this.query) : api.seed_word_asin_list_manager_lists(this.query)

            return tempPromise.then(res => {
                if (res.code === 0) {
                    this.cList = res.data.list
                    this.cList.forEach((item, index) => {
                        this.cList[index].rankInfo = {
                            rank_page_1: undefined,
                            rank_page_2: undefined,
                            rank_page_3: undefined
                        }
                        this.cList[index].rankChangeInfo = {
                            rank_page_1_change: undefined,
                            rank_page_2_change: undefined,
                            rank_page_3_change: undefined
                        }

                        this.cList[index].adChangeInfo = {
                            ad_rank_page_1_change: undefined,
                            ad_rank_page_2_change: undefined,
                            ad_rank_page_3_change: undefined
                        }
                        this.cList[index].adInfo = {
                            ad_rank_page_1: undefined,
                            ad_rank_page_2: undefined,
                            ad_rank_page_3: undefined
                        }
                    })
                    this.query.page = res.data.page
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
                this.list = this.cList
                this.loading = false

                // this.getPageTotal()
            })
                .catch(() => {
                    this.loading = false
                })
        },
        //修改关联关系
        onRelevance(data) {
            if (data.ad_portfolio_name_id !== 0) {
                return
            }
            this.formData = JSON.parse(JSON.stringify(data))
            this.$refs.relevance.onList()
            this.$refs.relevance.onArr([...data.relevance_list])
            this.ctrl.relevanceDialogVisible = true
        },
        //更新
        ondetail(data) {
            this.loading = true
            api.update_asin_detail({
                asin: data.asin,
                state: data.state
            })
                .then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.getList()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
                .catch(() => {
                    this.loading = false
                })
        },
        //跳转到内部竞价
        onJump(data, isNew = false) {
            let url = `/statistics/index?asin=${data.asin}&state=${data.state}&isNew=${isNew}&ad_portfolio_name_id=${data.ad_portfolio_name_id}&id=${data.id}`
            // this.$router.push({path: url})
            localStorage.setItem('spData', JSON.stringify(data))
            window.open(this.$router.resolve({path: url}).href, '_blank')
        },
        onSBJump(data, isNew = false) {
            // this.$router.push({
            //     path: "/adGroup/inside?asin=" + data.parent_asin
            // });
            console.log('====', data)
            this.$router.push({
                path: `/statisticsSB/index?asin=${data.asin}&state=${data.state}&isNew=${isNew}&ad_portfolio_name_id=${data.id}&id=${data.id}`
                // query: data
            })
        },
        keywordRanking(data) {
            this.formData = JSON.parse(JSON.stringify(data))
            this.ctrl.keywordRankingVisible = true
        },
        //上传自动否定无效词根
        onupload(data) {
            this.formData = data
            this.ctrl.dialogTitle = data.asin + ' 上传自动否定无效词根'
            this.ctrl.upload1DialogVisible = true
        },
        //查看词根单复数
        onplural() {
            this.ctrl.dialogTitle = '查看词根单复数'
            this.ctrl.pluralDialogVisible = true
            this.$refs.plural.getList()
        },
        //Auto优化
        autoOptimize(state) {
            this.ctrl.dialogTitle = (state === 'NA' ? '美国' : '欧洲') + 'Acos优化'
            this.ctrl.autoOptimizeVisible = true
            this.$refs.autoOptimizeRef.state = state
            this.$refs.autoOptimizeRef.getList()
        },
        // 导出
        exportFunc() {
            api.seed_word_asin_list_export().then((res) => {
                if (res.success) {
                    this.downFile(res.data)
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
        },
        // 店铺名称列表
        nameList() {
            this.ctrl.uploadFileListVisible = true
        },
        //添加备注
        addremark(data, str) {
            if (str == '负责人') {
                this.formData = {
                    res_person_value: data.res_person,
                    parent_asin: data.asin,
                    id: data.id
                }
            } else {
                this.formData = {
                    remark: data.remark,
                    parent_asin: data.asin,
                    id: data.id
                }
            }
            this.ctrl.onremarkDialogVisible = true
            this.ctrl.dialogTitle = str
        },
        //打开记录
        recordOpen(data) {
            this.formData = {
                parent_asin: data.asin,
                state: data.state,
                record_id: data.id,
            }
            this.ctrl.recordDialogVisible = true
        },
        sbvOpen(data, flag) {
            this.formData = {
                ad_portfolio_name: data.ad_portfolio_name,
                asin: data.asin,
                state: data.state,
            }
            if (flag) {
                this.parse.title = 'SBV广告组合解析列表'
                this.parse.type = 'SBV'
            } else {
                this.parse.title = 'SB广告组合解析列表'
                this.parse.type = 'SB'
            }
            this.ctrl.sbvParseVisible = true
        },
        sdOpen(data, flag) {
            this.formData = {
                ad_portfolio_name: data.ad_portfolio_name,
                asin: data.asin,
                state: data.state,
            }
            this.ctrl.sdParseVisible = true
        },
        //点击展开
        clickRowHandle(row, column) {
            if (column.label !== '') {
                if (column.label == '备注') {
                    this.addremark(row, '备注')
                }
                if (column.label == '项目预算asin') {
                    this.$refs.updateAsinModalRef.openModal('项目预算asin', row)
                }
                if (this.pageType === 1 && column.label == '负责人') {
                    this.$refs.changeUserDom.openModal(row, this.managerAnalysisList, 1)
                }
                if (this.pageType === 1 && column.label == '广告控制人') {
                    this.$refs.changeUserDom.openModal(row, this.managerAnalysisList, 2)
                }
                if (column.label == '广告组合') {
                    this.bindAdGroupName(row)
                }
                if (column.label == '不再运营原因') {
                    this.$refs.updateReasonModalRef.openModal('不再运营原因', row)
                }
                if (['标题'].includes(column.label)) {
                    this.childInfo = {
                        title: column.label,
                        info: row.asin_title,
                    }
                    this.ctrl.childInfoVisible = true
                }
            }
        },
        openUrlOnWindow() {
            if (this.openUrlAsin.trim() == '') {
                this.$message.info('asin 不能为空')
                return
            }
            const amazonLinks = ['https://www.amazon.com/dp/', 'https://www.amazon.ca/dp/', 'https://www.amazon.com.mx/dp/', 'https://www.amazon.co.uk/dp/',
                'https://www.amazon.de/dp/', 'https://www.amazon.fr/dp/', 'https://www.amazon.it/dp/', 'https://www.amazon.es/dp/', 'https://www.amazon.co.jp/dp/',]

            for (const item of amazonLinks) {
                window.open(`${item}${this.openUrlAsin}`, '_blank')
            }
        },
        clickRowHandle(row, column) {
            if (column && column.type === 'expand') {
                this.$refs.multipleTable.toggleRowExpansion(row)
            }
        },
        clickRowHandle1(row) {
            if (this.expands.includes(row.id)) {
                this.expands = this.expands.filter(
                    val => val !== row.id
                )
            } else {
                this.expands.push(row.id)
                let str = 'inline' + row.id
                this.$nextTick(() => {
                    this.$refs[str].handleClick()
                })
            }
        },
        //添加文件夹
        add() {
            this.ctrl.addDialogVisible = true
        },
        negativeMapping() {
            this.ctrl.negativeMappingVisible = true
        },
        //上传词根数据
        on_file_upload(data, str) {
            this.formData = JSON.parse(JSON.stringify(data))
            this.ctrl.uploadDialogVisible = true
            this.ctrl.dialogTitle = str
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //重置
        onReset() {
            this.query.page = 1
            this.query.limit = 20
            this.query.asin = ''
            this.query.using = undefined
            this.getList()
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.keywordRankingVisible = false
            this.ctrl.uploadFileListVisible = false
            this.ctrl.addDialogVisible = false
            this.ctrl.negativeMappingVisible = false
            this.ctrl.uploadDialogVisible = false
            this.ctrl.onremarkDialogVisible = false
            this.ctrl.upload1DialogVisible = false
            this.ctrl.pluralDialogVisible = false
            this.ctrl.autoOptimizeVisible = false
            this.ctrl.relevanceDialogVisible = false
            this.ctrl.recordDialogVisible = false
            this.ctrl.sbvParseVisible = false
            this.ctrl.sdParseVisible = false
            this.ctrl.childInfoVisible = false
            if (isshow) return
            this.getList()
        },
        bindAdGroupName(adGroupData) {
            this.showAdGroup = true
            this.adGroupData = adGroupData
        },
        closeAdGroupName() {
            this.showAdGroup = false
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.asin_url_href, '_blank')
        },
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    white-space: normal;
}

.scrollHeight {
    height: 60px;
    line-height: 15px;
    overflow-y: auto;
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}

.ceil-span {
    margin: 0 5px;
    width: 40px;
    float: left;
}

// .ceil-color {
//   color: #ff0000;
// }
.ceil-color_green {
    color: #00e640;
}

.ceil-color_red {
    color: #ff0000;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    cursor: pointer;
    // background-color: rgb(221, 233, 255) !important;
    background-color: #fff !important;
}

/deep/ .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell[class*="cell"] {
    padding: 0 !important;
}

/deep/ .el-table td.el-table__expand-column {
    cursor: pointer;
    &:hover {
        .el-table__expand-icon {
            color: #409EFF;
        }
    }
}

.pen:hover {
    cursor: pointer;
    text-decoration: underline;
}

.table_content {
    height: calc(100vh - 190px);
    overflow: auto;
    border: 1px solid #ebeef5;
}

/deep/ .el-table::before {
    display: none;
}

/deep/ .el-table td.asin-column-cell,
/deep/ .el-table td.asin-column-cell .cell {
    overflow: visible !important;
}

.asin-invalid-stamp-img {
    position: absolute;
    top: -24px;
    right: -22px;
    width: 35px;
    height: auto;
    pointer-events: none;
    z-index: 3;
    opacity: 0.95;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}
</style>
